<template>
  <v-footer
    height='auto'
    color='primary'
    app
    class='pa-0'
  >
    <v-layout
      justify-center
      row
      wrap
      class='ma-0'
    >
      <v-row
        primary
        text-xs-center
        white--text
        xs12
        align='center'
        class='ma-0'
      >
        <v-col class='pa-0'>
          <v-img
            alt='N.V. Havenbeheer Suriname'
            class='shrink mr-2'
            contain
            src='@/assets/logobotRetina.png'
            transition='scale-transition'
            width='50'
          />
        </v-col>
        <v-col>
        &copy;2020 — <strong>N.V. Havenbeheer Suriname</strong>. All rights reserved.
        </v-col>
        <v-col>
        </v-col>
      </v-row>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  name: 'HBSFooter',
  data: () => ({
    links: [
      'Home',
      'About Us',
      'Team',
      'Services',
      'Blog',
      'Contact Us',
    ],
  }),
};
</script>

<style scoped>

</style>
